const langItArca = {
	enum_product_attribute_BIOLOGICAL_label: 'Colazione',
};
export default langItArca;
